var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"step2 step2active question success active\"><h2>Verify Your Identity with {{ vendor_name }}</h2><img src=\"{{success_svg}}\" width=\"130\" alt=\"\"><h2 class=\"head-success\">Success!</h2><p ng-if=\"context == 'landlord'\">{{ vendor_name }} credit reports have been automatically added to forms you've created</p><p ng-if=\"context == 'applicant'\">Your identity has been verified</p><div class=\"cf\"></div><a href=\"#\" ng-if=\"context == 'landlord'\" ng-click=\"go_to_dashboard()\" class=\"create btn_next\">{{ $root.stored_form_data ? 'Return to Select Reports' : 'Return to Dashboard' }}</a><a href=\"#\" ng-if=\"context == 'applicant' || context == 'applicant-payment'\" ng-click=\"next()\" class=\"create btn_next\">Next</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/verifications/success/success.jade
// module id = 1123
// module chunks = 0